import { useState, useEffect, useContext, useMemo, useRef } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

import SuiBox from "components/SuiBox";
import SuiInput from "components/SuiInput";

import Card from "@mui/material/Card";

import toast from "react-hot-toast";
import moment from "moment";

import Prompt from "components/UpStyled/Prompt";
import api from "services/api";
import { nanoid } from "nanoid";

import EventCalendar from "examples/Calendar";
import AddEventModal from "pages/de/dashboard/components/AddEventModal";
import Flatpickr from "react-flatpickr";
import SuiTypography from "components/SuiTypography";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Checkbox from "@mui/material/Checkbox";
import SuiButton from "components/SuiButton";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";

import AddIcon from "@mui/icons-material/Add";
import IosShareIcon from "@mui/icons-material/IosShare";
import GetAppOutlinedIcon from "@mui/icons-material/GetAppOutlined";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";

import { colorOptions } from "utils/data";
const Color = require("color");

const ColorDropDownMenu = ({
  color = {},
  size = 20,
  onClick = () => {},
  onAddColor = () => {},
}) => {
  const [changeColorVisible, setChangeColorVisible] = useState(null);
  const [customizeColorVisible, setCustomizeColorVisible] = useState(false);
  const [newColor, setNewColor] = useState("#000000");

  const handleCloseChangeColorMenu = () => setChangeColorVisible(false);
  const ColorMenu = () => (
    <Menu
      id="calendar-action-menu"
      anchorEl={changeColorVisible}
      open={Boolean(changeColorVisible)}
      onClose={handleCloseChangeColorMenu}
      MenuListProps={{
        "aria-labelledby": "basic-button",
      }}
    >
      <SuiBox sx={{ p: 1, maxWidth: 160 }}>
        {colorOptions.map((item) => (
          <Tooltip title={item?.label}>
            <SuiBox
              width={size}
              height={size}
              sx={{
                display: "inline-block",
                backgroundColor: item?.value,
                borderRadius: "50%",
                cursor: "pointer",
                transition: "transform .2s",
                "&:hover": {
                  transform: `scale(1.2)`,
                },
                mr: 0.5,
              }}
              onClick={() => {
                handleCloseChangeColorMenu();
                onClick(item);
              }}
            />
          </Tooltip>
        ))}
        <Tooltip title={"Custom color"}>
          <SuiBox
            width={20}
            height={20}
            sx={{
              display: "inline-block",
              mr: 0.5,
              backgroundColor: "#eeeeee",
              textAlign: "center",
              verticalAlign: "middle",
              borderRadius: "50%",
              cursor: "pointer",
              transition: "transform .2s",
              "&:hover": {
                transform: `scale(1.2)`,
              },
              mt: -1,
            }}
            onClick={() => {
              handleCloseChangeColorMenu();
              setCustomizeColorVisible(true);
            }}
          >
            <AddIcon color="secondary" />
          </SuiBox>
        </Tooltip>
      </SuiBox>
    </Menu>
  );

  return (
    <SuiBox>
      <SuiBox
        width={20}
        height={20}
        sx={{
          backgroundColor: color?.value,
          borderRadius: "50%",
          cursor: "pointer",
        }}
        onClick={(e) => (onClick ? setChangeColorVisible(e.target) : null)}
      />
      <ColorMenu />
      {customizeColorVisible ? (
        <Prompt
          visible={customizeColorVisible}
          handleClose={() => setCustomizeColorVisible(false)}
          handleOk={() => {
            try {
              Color(newColor);
            } catch (err) {
              return toast.error("Invalid color code!");
            }
            setCustomizeColorVisible(false);
            onClick({
              label: newColor,
              value: newColor,
            });
          }}
          option={{
            fullWidth: true,
            maxWidth: "xs",
          }}
          heading="Choose custom color"
          text={
            <SuiBox sx={{ px: 2 }}>
              <SuiBox display="flex" alignItems="center" gap={2} py={1}>
                <input
                  type="color"
                  value={newColor}
                  onChange={(e) => {
                    const hex = e.target.value.toUpperCase();
                    setNewColor(hex);
                  }}
                />
                <SuiInput
                  value={newColor}
                  onChange={(e) => {
                    let value = e.target.value.toUpperCase();
                    value = value.replace(/[^\dA-F]/g, "");
                    if (!value.startsWith("#")) {
                      value = "#" + value;
                    }

                    setNewColor(value);
                  }}
                  inputProps={{ maxLength: 7 }}
                />{" "}
              </SuiBox>
            </SuiBox>
          }
        />
      ) : null}
    </SuiBox>
  );
};

export default ColorDropDownMenu;
